import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner-overlay',
  templateUrl: './spinner-overlay.component.html',
  styleUrl: './spinner-overlay.component.scss',
  standalone: false
})
export class SpinnerOverlayComponent {
  @Input() isLoading = false;
}
